__turbopack_context__.v({
  "controlsHost": "styles-module__shG7PW__controlsHost",
  "mobileCroppedStage": "styles-module__shG7PW__mobileCroppedStage",
});
